// components/SearchHeader.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, X, SearchIcon } from 'lucide-react';
import TableDropDownSmall from 'pages/Components/TableDropDownSmall';

interface SearchHeaderProps {
  totalItems: number;
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSelectNumber: (value: number) => void;
  onAddNew: () => void;
  showAddButton: boolean;
}

const SearchHeader: React.FC<SearchHeaderProps> = ({
  totalItems,
  searchValue,
  onSearchChange,
  onSelectNumber,
  onAddNew,
  showAddButton
}) => {
  return (
    <div className="flex flex-col gap-4 mb-4 md:flex-row md:items-center md:justify-between">
      <div className="w-full md:w-auto">
        <h6 className="text-15 mb-2">
          مجموع بار ها (<b className="total-Employs">{totalItems?.toString()}</b>)
        </h6>

        <label className="flex flex-col gap-2 mb-2 sm:flex-row sm:items-center">
          <span className="whitespace-nowrap p-1">جست‌وجو:</span>
          <div className="relative w-full sm:w-64">
            <input
              type="text"
              className="w-full border p-1 border-gray-200 rounded-sm text-black dark:bg-gray-800 dark:text-white pl-8 py-1"
              placeholder="جستجو..."
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            <span className="absolute top-0 inset-y-0 left-2 flex items-center text-gray-400">
              {searchValue ? (
                <X
                  size={15}
                  className="cursor-pointer"
                  onClick={() => onSearchChange('')}
                />
              ) : (
                <SearchIcon size={15} />
              )}
            </span>
          </div>
        </label>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row sm:gap-3">
        <div className="w-full sm:w-auto">
          <TableDropDownSmall onSelect={onSelectNumber} />
        </div>
        {showAddButton && (
          <div className="w-full sm:w-auto shrink-0">
            <Link
              to="#"
              onClick={onAddNew}
              type="button"
              className="block text-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
            >
              <span className="align-middle rtl">ایجاد بار جدید</span>{' '}
              <Plus className="inline-block size-4 rtl" />
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchHeader;
